'use strict';

var _slicedToArray = require("C:\\Users\\Gralath\\Documents\\VECHAIN\\voting-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var debug = require('debug')('thor:injector');

var Subscription = require('web3-core-subscriptions').subscription;

var formatters_1 = require("./formatters");

var extendContracts = function extendContracts(web3) {
  var _encodeEventABI = web3.eth.Contract.prototype._encodeEventABI;

  web3.eth.Contract.prototype._encodeEventABI = function (event, options) {
    debug('_encodeEventABI');

    var result = _encodeEventABI.call(this, event, options);

    if (options.options) {
      result.options = options.options;
    }

    if (options.range) {
      result.range = options.range;
    }

    if (options.order) {
      result.order = options.order;
    }

    return result;
  };

  web3.eth.Contract.prototype._on = function () {
    debug('_on'); // keeps the code from web3

    var subOptions = this._generateEventOptions.apply(this, arguments); // prevent the event "newListener" and "removeListener" from being overwritten


    this._checkListener('newListener', subOptions.event.name, subOptions.callback);

    this._checkListener('removeListener', subOptions.event.name, subOptions.callback); // TODO check if listener already exists? and reuse subscription if options are the same.
    // create new subscription

    /* changes from web3 starts the following
     */
    // subscription options in thor doesn't support array as topic filter object


    var filterOptions = {
      address: subOptions.params.address
    };
    debug('Contract filter option: %O', filterOptions);

    if (subOptions.params.topics) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = subOptions.params.topics.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 2),
              index = _step$value[0],
              value = _step$value[1];

          if (value === null) {
            continue;
          }

          if (typeof value === 'string') {
            filterOptions['t' + index] = value;
          } else {
            throw new Error('[thorify] Array filter option is not supported in thor, must be null or bytes32 string');
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }

    var decodeEventABI = this._decodeEventABI.bind(subOptions.event);

    var subscription = new Subscription({
      subscription: {
        params: 1,
        inputFormatter: [formatters_1.inputLogFilterFormatter],
        subscriptionHandler: function subscriptionHandler(subscriptionMsg) {
          if (subscriptionMsg.error) {
            this.emit('error', subscriptionMsg.error); // web3-core-subscriptions/subscription sets a default value for this.callback

            this.callback(subscriptionMsg.error, null, this);
          } else {
            var result = decodeEventABI(subscriptionMsg.data);

            if (result.removed) {
              this.emit('changed', result);
            } else {
              this.emit('data', result);
            } // web3-core-subscriptions/subscription sets a default value for this.callback


            this.callback(null, result, this);
          }
        }
      },
      type: 'eth',
      requestManager: this._requestManager
    });
    subscription.subscribe('logs', filterOptions, subOptions.callback || function () {});
    return subscription;
  };
};

exports.extendContracts = extendContracts;